<template>
  <div class="boxide" id="boxIde">
    <!--遮盖蒙版-->
    <div id="ide_mask"></div>

    <splitpanes @resize="panesResize" id="game_and_ide" :horizontal="UIHorizontal">
      <!--canvas显示区-->
      <pane id="boxide_lefts" size="40" min-size="20" max-size="60">
        <div id="GameDiv">
          <canvas id="GameCanvas"></canvas>
          <div id="splash">
            <div class="progress-bar stripes">
              <span style="width: 0"></span>
            </div>
          </div>
        </div>
        <div id="mapId" v-if="gameId < 99999">ID: {{ mapId }}</div>
        <div id="tool_tip"
        :style="{backgroundImage: 'url('+createURL+'/static/images/tooltips.png)', backgroundSize:'100% 100%'}"
        >
          <p id="tool_tip_content"></p>
        </div>
      </pane>

      <!--右边容器  -->
      <pane id="boxide_right" class="boxide_right" v-if="chooseMode != '0'">
        <div class="boxide_left">
          <splitpanes horizontal>
            <pane id="commentArea" v-if="GameLevelSetting.comments && commentShow"  :dir="dirs" size="40" class="markdown-body">
              <div v-html="commentInfoHTML"></div>
            </pane>
            <pane id="code-area" min-size="30"></pane>
          </splitpanes>
        </div>

        <div id="boxIde-rightMask" v-show="ideMask" ></div>
        
        <!-- 当有注释时显示 -->
        <div class="questionMark" ref="questionMark" v-if="GameLevelSetting.comments" @click="toggleComments()"></div>
        
        <div class="openAudio" ref="audio02" @click='toggleAudio()'></div>
        
        <!-- 以色列新增WhatsApp求组按钮-->
        <!-- <div class='whatsapp' v-show="$i18n.locale == 'he'">
          <div class='whatsapp_button' 
            :style="{backgroundImage: 'url('+createURL+'/static/images/WhatsApp.png)',backgroundSize:'contain'}"
            onclick="window.open('https://wa.me/+972533511154','mywindow');" style="cursor: pointer;"
            ></div>
          <p dir="auto" class="whatsapp_tip">{{ $t("need_help") }}</p>
        </div> -->
        
        <div class='audio' v-show="audioOpenShow" :style="{backgroundImage: 'url('+createURL+'/static/images/audio/' + lang + '/sign03.png)',backgroundSize:'contain'}"></div>

        
        <div style="width:100%;height:100%;position: absolute;z-index: 111110;" v-show="codeShow"></div> 
        
      </pane>

      <pane id="boxide_right" class="boxide_right" v-else>
        <blockly></blockly>    
      </pane>
    </splitpanes>

    <!--展示注释图片 ../../../static/images/comment/comment_1.png-->
    <!-- <div class="boxide_right_notes" v-if='CommentImgList'>
      <img id="image" :src='imagePath' alt="" @load='changeImg()' @error="changeImgError()">
    </div> -->

    
    <!--右边容器下方-->
    <div id="boxide_bottom" v-show="chooseMode != '0'">

      <!-- 按钮区域 中心背景 -->
      <div id="regionCenter" class="regionCenter">
        <ul id="regionCenterUL" class="regionCenterUL">
          <li
            class="animated codeButton"
            v-for="(item,index) in funVisibleArr"
            @click="clickActionImageButton(item,index)"
            :title="item.tips"
            ref="regionCenterLi"
            :key="index"
          >
            <img ref="liImg" class="regionImges" :src="item.img" alt ondragstart="return false;">
            <p :dir="dirs">{{item.describe}}</p>
          </li>
        </ul>
        <p
          class="actionSelectLeft"
          @click="actionSelectLeft"
          v-show="funIndex > 0"
        ></p>
        <p
          class="actionSelectRight"
          @click="actionSelectRight"
          v-show="(funIndex + funShowCount < funArr.length) && (funShowCount > 0)"
        ></p>
      </div>
      <!-- 按钮区域 右边背景 -->
      <div class="regionRight">
        <div class="btnRun" id="runCode" @click="clickRunCode"></div>
        <div class="resetButton"  @click="clickResetCode"></div>
        <div class="stopButton" id="stopCode" @click="clickStopCode"></div>
      </div>
    </div>

    <!-- Editor Tools -->
    <div v-if="isEditor" class="topleft" @click="toggleEditorWindow">✎ Edit</div>
    
    <splitpanes v-if="editorWindowShow" class="editorWindow" horizontal>
      <pane>
        <p >Comments</p>
        <textarea id="editorComment" :dir="dirs"></textarea>
      </pane>
      <pane>
        <splitpanes>
          <pane>
            <p>Default Code</p>
            <div id="editorDefaultCode"></div>
          </pane>
          <pane>
            <p @click="setFullCode">Full Code (click to write into the code area)</p>
            <div id="editorFullCode"></div>
          </pane>
        </splitpanes>
      </pane>
      <pane size="15" min-size="10">
        <span>Min Lines<input id="minLines" type="number"></span>
        <span>Min Steps<input id="minSteps" type="number"></span>

        <!-- buttons -->
        <div class="buttonList">
          <div class="button" @click="editorPreview">Preview</div>
          <div class="button" @click="SubmitToServer">Save</div>
          <div class="button" @click="editorWindowShow = false" style="background: lightcoral;">X Close</div>

          <div class="button" @click="queryGameLevelSetting('en')">↓ EN</div>
          <div class="button" @click="queryGameLevelSetting('zh')">↓ CN</div>
        </div>
      </pane>
    </splitpanes>

  </div>
</template>

<script>
import store from "../../store";
import { mapGetters } from "vuex";
import blockly from "./blockly.vue";
import AdventureManager from "../../manager/AdventureManager";
import { loadScriptsInOrder } from "../../utils/loadScript";
import { runCppCode, initCppCheck, initCppEnvironment } from "../../libs/cpp";
import markdownit from 'markdown-it';

import HttpService from '../../service/HttpService'; //引入axios配置
import Qs from 'qs';

import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import hljs from 'highlight.js';

const md = markdownit({
  html: true,
  linkify: true,
  typographer: true,
  theme: "dark",
  breaks: true,
  langPrefix:   'language-',
  highlight: function (str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return '<pre><code class="hljs" dir="ltr">' +
               hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
               '</code></pre>';
      } catch (__) {}
    }

    return '<pre><code class="hljs" dir="ltr">' + md.utils.escapeHtml(str) + '</code></pre>';
  }
});

export default {
  data() {
    return {
      timerId: null,
      shrinkBar: true,
      mouseOverResetButton: false,
      mouseOverStopButton:false,
      createURL:process.env.GAME_CREATE_URL,
      IMG_BASE_URL: process.env.IMG_BASE_URL,
      notesImg:'',
      audioFlag:false,
      audioOpenShow:true,

      MODE: {
        Python: 0,
        Blockly: 1,
        Cpp: 2,
      },
      editor: undefined,
      show_knowledge_tips: true, // 是否展示知识点框

      // 展示注释，markdown格式
      commentInfo: null,
      commentInfoHTML: null, 
      commentShow: true,

      UIHorizontal: false,
      isEditor: false,
      editorWindowShow: false,
      commentEditor: undefined,

      aceMode: undefined,

      isUseDefaultCode: false,
      GameLevelSetting: {
        gameId: undefined,
        levelId: undefined,
        mapId: undefined,
        language: undefined,
        comments: undefined,
        defaultCode: undefined,
        fullCode: undefined,
        minLines: undefined,
        minSteps: undefined,
      }
    };
  },
  components: {
    blockly,
    Splitpanes,
    Pane
  },
  mounted() {

    this.lang = AdventureManager.getLanguage();
    this.$i18n.locale = this.lang;
    store.state.locale = this.lang;

    this.$nextTick(function() {
      window.addEventListener("resize", this.ideResize);
    });

    // 更新是否显示知识点按钮tips状态
    setInterval(()=> {
      this.update_knowledge_tips_statu();
    }, 3000);
    this.init_tooltip();

    $(".regionImges").on("mousedown", function(e) {
      e.preventDefault();
    });

    window._ide_print_interval = 0.05;

    store.state.chooseMode = AdventureManager.getQueryVariable("mode"); // 先于 online class 初始化
    store.state.gameId = AdventureManager.getQueryVariable("game");

    this.isEditor = AdventureManager.getQueryVariable("editor");
    this.boxIde = document.querySelector("#boxIde");
    this.initEditor();
  },
  methods: {
    editorPreview() {
      this.GameLevelSetting.comments = this.commentEditor.value;
      this.commentInfoHTML = md.render(this.GameLevelSetting.comments);

      this.editor.setValue(this.defaultCodeEditor.getValue());
    },

    initEditorWindow() {
        this.commentEditor = document.querySelector("#editorComment");

        this.defaultCodeEditor = ace.edit("editorDefaultCode");
        this.defaultCodeEditor.session.setUseWrapMode(true); // 允许自动换行
        this.defaultCodeEditor.setFontSize('16px');
        this.defaultCodeEditor.session.setMode(this.aceMode);

        this.fullCodeEditor = ace.edit("editorFullCode");
        this.fullCodeEditor.session.setUseWrapMode(true); // 允许自动换行
        this.fullCodeEditor.setFontSize('16px');
        this.fullCodeEditor.session.setMode(this.aceMode);
    },

    toggleEditorWindow() {
      this.editorWindowShow = !this.editorWindowShow;
      if(this.editorWindowShow == false) return;

      this.$nextTick(() => {
        this.initEditorWindow();
        this.editorUpdate();
      })      
    },

    queryGameLevelSetting(language) {

      HttpService("game/queryGameLevelSetting", {
        method: 'post',
        data: Qs.stringify({
          gameId: store.state.gameId,
          levelId: window.bridge.getCurrentLevelData().levelid,
          language: language // from default setting
        })
      }).then(res => {
        let data = res.data ? res.data.data : {};

        // clear all
        this.GameLevelSetting =  {
          gameId: undefined,
          levelId: undefined,
          mapId: undefined,
          language: undefined,
          comments: undefined,
          defaultCode: undefined,
          fullCode: undefined,
          minLines: undefined,
          minSteps: undefined,
        };

        Object.assign(this.GameLevelSetting, data);
        this.afterGameLevelSetting();
        
      })
    },

    afterGameLevelSetting() {
      this.commentInfoHTML = md.render(this.GameLevelSetting.comments || "");

      store.state.minLine = this.GameLevelSetting.minLines ? parseInt(this.GameLevelSetting.minLines) : store.state.minLine;
      store.state.minStep = this.GameLevelSetting.minSteps ? parseInt(this.GameLevelSetting.minSteps) : store.state.minStep;

      this.configLine = store.state.minLine;
      this.configStep = store.state.minStep;
      // store.state.mapId = stageInfo.rawLevel; 

      if(this.isUseDefaultCode && this.GameLevelSetting.defaultCode) {
        this.editor.setValue(this.GameLevelSetting.defaultCode);
      }

      AdventureManager.showExplainDialog(window.bridge.getCurrentLevelData().levelid);
      
      this.$nextTick(() => {
        if(this.commentEditor) {
          this.editorUpdate();
        }
        this.addClassToCommentArea();
      })
    },

    addClassToCommentArea() {
      const commentArea = document.querySelector("#commentArea");
      if(commentArea){
        commentArea.classList.add("markdown-" + (store.state.chooseMode == this.MODE.Cpp ? "cpp" : "python"));
      }
    },

    editorUpdate() {
      this.commentEditor.value = this.GameLevelSetting.comments || "";
      this.defaultCodeEditor.setValue(this.GameLevelSetting.defaultCode || "");
      this.fullCodeEditor.setValue(this.GameLevelSetting.fullCode || "");

      document.querySelector("#minLines").value = this.GameLevelSetting.minLines || store.state.minLine;
      document.querySelector("#minSteps").value = this.GameLevelSetting.minSteps || store.state.minStep;
    },

    SubmitToServer() {
      this.editorPreview();

      this.GameLevelSetting = {
        gameId: store.state.gameId,
        levelId: window.bridge.getCurrentLevelData().levelid,
        language: this.$i18n.locale,
        mapId: this.mapId,
        comments: this.commentEditor.value,
        defaultCode: this.defaultCodeEditor.getValue(),
        fullCode: this.fullCodeEditor.getValue(),

        minLines: document.querySelector("#minLines").value,
        minSteps: document.querySelector("#minSteps").value,
      }
      store.state.minLine = this.GameLevelSetting.minLines;
      store.state.minStep = this.GameLevelSetting.minSteps;

      this.editor.setValue(this.GameLevelSetting.fullCode);
      
      HttpService("game/insertGameLevelSetting", {
        method: 'post',
        data: Qs.stringify(this.GameLevelSetting),
      }).then(res => {
        this.editorWindowShow = false;
        this.addClassToCommentArea();
      })
    },

    setFullCode() {
      this.editor.setValue(this.fullCodeEditor.getValue());
    },

    // 父节点调用
    updateGameLevelSetting() {
      this.queryGameLevelSetting(this.$i18n.locale);
      
      // let levelId = window.bridge.getCurrentLevelData().levelid;

      // let Mars_CommentInfo = store.state.GameConfig["Mars_CommentInfo"];
      // if(Mars_CommentInfo && Mars_CommentInfo[levelId]){
      //   let levelCommentInfo = Mars_CommentInfo[levelId];
      //   this.commentInfo = levelCommentInfo[this.lang] || levelCommentInfo['en'];
      //   this.commentInfoHTML = md.render(this.commentInfo);
      // } 

    },

    async initEditor() {
      if(store.state.chooseMode == '0') return; // blockly 

      let scriptList = [];
      let theme;

      if(store.state.chooseMode == '1') { // Python
        this.boxIde.classList.add('python');
        theme = "ace/theme/twilight";

        scriptList = [
          "./static/lib/ace/ace.js",
          "./static/lib/ace/ext-language_tools.js",
          "./static/game/mars_brython.js",
          "./static/game/brython_stdlib.js",
          // "./static/game/player_code.py"
        ];

        await loadScriptsInOrder(scriptList);

        // 需要单独加载
        const script = document.createElement('script');  
        script.src = "./static/game/player_code.py"; 
        script.type = "text/python3";
        document.head.appendChild(script);  
        
        this.aceMode = "ace/mode/python";
        brython();

      } else if (store.state.chooseMode == this.MODE.Cpp) { // C++
        this.boxIde.classList.add('cpp');
        theme = "ace/theme/solarized_light";
        scriptList = [
          "./static/lib/ace-1.38.0/src-min/ace.js",
          "./static/lib/ace-1.38.0/src-min/ext-language_tools.js",
          "./static/lib/ace-1.38.0/src-min/ext-beautify.js",
        ];
        await loadScriptsInOrder(scriptList);
        this.aceMode = "ace/mode/c_cpp";
      } else {
        console.log("Wrong game mode");
        return;
      }

      // 展示用作全局参数
      this.editor = ace.edit("code-area");
      this.editor.beautify = ace.require("ace/ext/beautify");
      
      window.editor = this.editor;
      this.editor.setTheme(theme);
      this.editor.session.setUseWrapMode(true); // 允许自动换行
      this.editor.setFontSize('18px');
      this.editor.session.setMode(this.aceMode);

      if (store.state.chooseMode == this.MODE.Cpp) {
        initCppEnvironment();
        initCppCheck(this.editor);
      }
    },

     // 获取img图片真实宽高
    getImageWidth(url,callback){
      var img = new Image();
      img.src = url;
      // 如果图片被缓存，则直接返回缓存数据
      if(img.complete){
        callback(img.width, img.height);
      }else{
        img.onload = function(){
          callback(img.width, img.height);
        }
      }
    },

    changeImg(){
      let imgSrc = $("#image").attr("src");
      this.getImageWidth(imgSrc,(w,h)=>{
        let H = h + 'px';
        $('.boxide .boxide_right').css({"top":'175px'})
      });
    },

    toggleComments(){
      this.commentShow = !this.commentShow;
      this.$nextTick(() => {
        this.addClassToCommentArea();
      });
    },

    changeImgError(){
    },

    // 开关背景音乐
    toggleAudio(){
      store.state.audioShow = !store.state.audioShow;
      window.bridge.toggleMusic(store.state.audioShow);
    },

    //代码重置
    clickResetCode() {
      store.state.toBack = true;
      store.state.skipStyleShow = false
      AdventureManager.sendToGame("showResetCodeDialog");
    },

    clickStopCode(){
      store.state.ideMask = false;
      store.state.codeShow = false;
      AdventureManager.sendToGame("stopRunAction");
    },


    //点击方法按钮,写入IDE代码
    clickActionImageButton(item,index) {
      this.$refs.regionCenterLi[index].classList.add('jello')
      // 如果代码正在运行, 则不处理
      if (window._code_is_running) {
        return;
      }
      if (this.timerId != null) {
        return;
      }
      let codeList = item.code.split("");
      let count = 0;
      this.timerId = setInterval(() => {

        if(!this.editor) { // Blockly 跳过
          clearInterval(this.timerId);
          return;
        }

        if (codeList.length == count) {
          clearInterval(this.timerId);
          this.timerId = null;
          // 如果时需要聚焦到具体位置
          if (item.focus) {
            let selectEnd = this.editor.getSelectionRange().end;
            let row = Math.max(0, selectEnd.row - 1);
            let value = this.editor.getValue();
            let lines = value.split("\n");
            let line = lines[row];
            let lineLength = line.length;
            let posInLine = Math.max(0, lineLength - 1);
            this.editor.selection.setRange({
              start: { row: row, column: posInLine },
              end: { row: row, column: posInLine }
            });
          }
          return;
        }
        this.editor.insert(codeList[count]);
        count++;
        // 代码区获取焦点
        this.editor.focus();

        this.$refs.regionCenterLi[index].classList.remove('jello')
      }, window._ide_print_interval * 1000);
    },

    panesResize() {
      window.dispatchEvent(new Event('resize'));
    },

    //窗口改变，自适应
    ideResize() {
      // this.UIHorizontal = !this.UIHorizontal;
      let UIHorizontal = this.boxIde.clientWidth*1.2 < this.boxIde.clientHeight;

      if(UIHorizontal != this.UIHorizontal) {
        this.UIHorizontal = UIHorizontal;
        this.$nextTick(()=>{
          AdventureManager.toFront_adaptGameFrameSize();
        })
      }

      AdventureManager.toFront_adaptGameFrameSize();
    },


    //点击运行按钮
    clickRunCode() {

      this.audioOpenShow = false

      // 防止未在IDE环境中执行、防止重复执行
      if (!window._inGame || window._code_is_running) {
        return;
      }

      $("#CanvasFrame").blur();
      
      store.state.ideMask = true;
      AdventureManager.updateCurrentCodeLines(); // 记录下行数
      
      // C++ 模式运行
      if(store.state.chooseMode == '2') {
        runCppCode(this.editor);
      }
    },


    // 向左选动作
    actionSelectLeft() {
      if (store.state.funIndex == 0) {
        return;
      }
      store.state.funIndex--;
      AdventureManager.toFront_adaptGameFrameSize();
    },
    // 向右选动作
    actionSelectRight() {
      if (
        store.state.funIndex + store.state.funShowCount >=
        store.state.funArr.length
      ) {
        return;
      }
      store.state.funIndex++;
      AdventureManager.toFront_adaptGameFrameSize();
    },

    // forbidBackSpace(e) {
    //   console.log(e)

    //   var ev = e || window.event; //获取event对象 
    //   var obj = ev.target || ev.srcElement; //获取事件源 
    //   var t = obj.type || obj.getAttribute('type'); //获取事件源类型 

    //   //获取作为判断条件的事件类型 
    //   var vReadOnly = obj.readOnly;
    //   var vDisabled = obj.disabled;
    //   //处理undefined值情况 
    //   vReadOnly = (vReadOnly == undefined) ? false : vReadOnly;
    //   vDisabled = (vDisabled == undefined) ? true : vDisabled;
    //   //判断 
    //   return false;
    // },

    update_knowledge_tips_statu(){
      try {
        let levelid = window.bridge.getCurrentLevelData().levelid;
        let tipsid = window.bridge.getCourseList(levelid) ? window.bridge.getCourseList(levelid).level.split(",")[0] : null;
        this.show_knowledge_tips = (levelid == tipsid);
      } catch (e){
        this.show_knowledge_tips = false;
      }      
    },

    // 以色列非要增加一个tooltip，但是cocos项目跑不起来，出此下策
    init_tooltip(){
      return; // 暂时移除
      document.querySelector("#GameCanvas").onmousemove = (e) => {
        let msg = "";
        let tool_tip = document.querySelector("#tool_tip");
        if(!tool_tip) return;

        let xPercent = e.clientX / document.body.clientWidth;

        if(e.clientY > 100 && e.clientY < 150){
          if(this.show_knowledge_tips && xPercent > 0.18 && xPercent < 0.21){          
            msg = this.$t("python"); // knowledge review
            tool_tip.style.left = "19.5%";
          } else if(xPercent > 0.22 && xPercent < 0.25){          
            msg = this.$t("speed_up");
            tool_tip.style.left = "24%";
          } else if (xPercent > 0.27 && xPercent < 0.30){
            msg = this.$t("show_grids");
            tool_tip.style.left = "28.5%";
          } else if (xPercent > 0.31 && xPercent < 0.34){
            msg = this.$t("zoom_in");
            tool_tip.style.left = "33%";
          } else if (xPercent > 0.36 && xPercent < 0.39){
            msg = this.$t("zoom_out");
            tool_tip.style.left = "37.5%";
          }
        }

        if(msg) {
          tool_tip.style.display = "block"
          document.querySelector("#tool_tip_content").innerHTML = msg;
        } else {
          tool_tip.style.display = "none";
        }
      }
    },

    update(dt) {
      // 
    }
  },
  computed: {
    ...mapGetters([
      "classIn",
      "courseware",
      "classTelescopic",
      "isLearning",
      "funArr",
      "funVisibleArr",
      "funShowCount",
      "funIndex",
      "ideMask",
      "allArr",
      "allImageMap",
      'CommentImgList',
      "imagePath",
      "audioShow",
      "lang",
      "skipStyleShow",
      "selectedPoint",
      "qrCodeShow",
      "codeShow",
      "blocklyShow",
      "chooseMode",
      "mapId",
      "gameId",
      "GameConfig",
      "configLine",
      "configSteps",
    ]),
    dirs(){
      if(this.lang == 'ar' || this.lang == 'he'){
        return 'rtl'
      }else{
        return 'ltr'
      }
    },
  },
};

</script>

<style src="../../css/ide-box.css"></style>


// WEBPACK FOOTER //
// src/components/onlineClass/idebox.vue